import React from 'react';
import PaypalLogo from '@tradera/blueprint/theme/logos/paypal.svg?next-image';
import MastercardLogo from '@tradera/blueprint/theme/logos/mastercard_vertical.svg?next-image';
import VisaLogo from '@tradera/blueprint/theme/logos/visa.svg?next-image';
import GooglePayLogo from '@tradera/blueprint/theme/logos/google-pay.svg?next-image';
import ApplePayLogo from '@tradera/blueprint/theme/logos/apple-pay.svg?next-image';
import KlarnaLogo from '@tradera/blueprint/theme/logos/klarna.svg?next-image';
import SwishLogo from '@tradera/blueprint/theme/logos/swish_horizontal.svg?next-image';
import PaynovaLogo from '@tradera/blueprint/theme/logos/paynova.svg?next-image';
import { Button } from 'tradera/components/atoms/button/button';
import DhlLogo from './dhl.svg?next-image';
import styles from './footer-partners.module.scss';
import { useCurrentLanguage } from 'tradera/lang/translate';
import { areLanguageCodesIso2Equal } from 'tradera/localization/languagecode';

export const FooterPartners = () => {
    const { language } = useCurrentLanguage();

    const partners = [
        {
            src: '/static/images/shipping/postnord.svg',
            alt: 'Postnord logo',
            height: 9,
            containerCss: styles.imageContainer,
            shouldRender: true
        },
        {
            src: '/static/images/shipping/schenker.svg',
            alt: 'Schenker logo',
            height: 9,
            containerCss: styles.imageContainer,
            shouldRender: true
        },
        {
            src: DhlLogo,
            height: 9,
            containerCss: styles.imageContainer,
            shouldRender: !areLanguageCodesIso2Equal(language, 'da')
        },
        {
            src: '/static/images/shipping/bring.svg',
            alt: 'Bring logo',
            height: 15,
            containerCss: styles.imageContainer,
            shouldRender: areLanguageCodesIso2Equal(language, 'da')
        },
        {
            src: '/static/images/shipping/gls.svg',
            alt: 'GLS logo',
            height: 15,
            containerCss: styles.imageContainer,
            shouldRender: !areLanguageCodesIso2Equal(language, 'sv')
        },
        {
            src: VisaLogo,
            height: 10,
            containerCss: styles.imageContainer,
            shouldRender: true
        },
        {
            src: MastercardLogo,
            height: 15,
            containerCss: styles.imageContainer,
            shouldRender: true
        },
        {
            src: SwishLogo,
            height: 15,
            containerCss: styles.imageContainer,
            shouldRender: areLanguageCodesIso2Equal(language, 'sv')
        },
        {
            logo: (
                <Button
                    theme="link"
                    href="https://info.tradera.com/klarna-betala-senare/"
                    target="_blank"
                    rel="noreferrer">
                    <img src={KlarnaLogo} height={15} />
                </Button>
            ),
            containerCss: styles.imageContainer,
            shouldRender: areLanguageCodesIso2Equal(language, 'sv')
        },
        {
            src: PaypalLogo,
            height: 12,
            containerCss: styles.imageContainer,
            shouldRender: true
        },
        {
            src: PaynovaLogo,
            height: 13,
            containerCss: styles.imageContainer,
            shouldRender: areLanguageCodesIso2Equal(language, 'sv')
        },
        {
            src: GooglePayLogo,
            height: 21,
            shouldRender: true
        },
        {
            src: ApplePayLogo,
            height: 21,
            shouldRender: true
        }
    ];

    return (
        <>
            {partners.map((partner, index) => {
                return partner.shouldRender ? (
                    <span
                        key={`partner_logo_${index}`}
                        className={`${
                            partner.containerCss
                                ? `${partner.containerCss} mr-1 pl-1 pr-1`
                                : 'pr-1'
                        } mb-2`}>
                        {partner.logo ? (
                            partner.logo
                        ) : (
                            <img
                                src={partner.src}
                                alt={partner.alt}
                                loading="lazy"
                                height={partner.height}
                            />
                        )}
                    </span>
                ) : null;
            })}
        </>
    );
};
